import { onCleanup, onMount, createSignal } from "solid-js";
import p5 from "p5";

const Mia = () => {
  let containerRef;
  let p5Instance = null;

  const [amplitude, setAmplitude] = createSignal(40); // Target amplitude
  const [smoothedAmplitude, setSmoothedAmplitude] = createSignal(0);
  const [isActive, setIsActive] = createSignal(false);
  const [smoothing, setSmoothing] = createSignal(true); // Control easing behavior

  let smoothingTimeout = null;

  const sketch = (p) => {
    let radius = 120;
    let frequency = 3;
    let phaseShift = 0;

    p.setup = () => {
      p.createCanvas(300, 300);
      p.angleMode(p.RADIANS);
      p.frameRate(30);
      p.noStroke();
    };

    p.draw = () => {
      p.background("#242424");
      p.translate(p.width / 2, p.height / 2);

      // Smooth transition only when smoothing is enabled
      const targetAmplitude = isActive() ? amplitude() : 0;

      let currentAmplitude;
      if (smoothing()) {
        const lerped = p.lerp(smoothedAmplitude(), targetAmplitude, 0.1);
        setSmoothedAmplitude(lerped);
        currentAmplitude = lerped;
      } else {
        currentAmplitude = amplitude();
        setSmoothedAmplitude(currentAmplitude); // sync smoothed with real
      }

      p.noFill();
      p.stroke(0);
      p.strokeWeight(0);
      p.circle(0, 0, radius * 2);

      p.stroke(242, 240, 239);
      p.strokeWeight(1.5);
      p.noFill();

      for (let j = 0; j < 61; j += 10) {
        let currentRadius = radius - j;
        p.beginShape();
        let totalPoints = 200;

        for (let i = 0; i <= totalPoints; i++) {
          let angle = p.map(i, 0, totalPoints, 0, p.TWO_PI);

          let x = currentRadius * p.cos(angle);
          let y = currentRadius * p.sin(angle);

          let displacement =
            currentAmplitude * p.sin(frequency * angle + phaseShift);
          let normalX = p.cos(angle);
          let normalY = p.sin(angle);

          let finalX = x + normalX * displacement;
          let finalY = y + normalY * displacement;

          p.vertex(finalX, finalY);
        }

        p.endShape(p.CLOSE);
      }
    };

    p.windowResized = () => {
      if (containerRef) {
        const width = Math.min(300, containerRef.offsetWidth);
        const height = Math.min(300, containerRef.offsetHeight);
        p.resizeCanvas(width, height);
      }
    };
  };

  const createGlobalAPI = () => {
    window.MiaAPI = {
      startSpeaking: () => {
        console.log("MiaAPI: startSpeaking");
        setIsActive(true);
        setSmoothing(true);
        clearTimeout(smoothingTimeout);
        smoothingTimeout = setTimeout(() => setSmoothing(false), 115);
      },
      updateAmplitude: (value) => {
        if (isActive()) {
          const scaledValue = 10 + Math.min(1, Math.max(0, value)) * 25;
          setAmplitude(scaledValue);
        }
      },
      stopSpeaking: () => {
        console.log("MiaAPI: stopSpeaking");
        setIsActive(false);
        setSmoothing(true); // Enable damping
        clearTimeout(smoothingTimeout);
      },
      isActive: () => isActive(),
      getAmplitude: () => amplitude(),
    };
  };

  onMount(() => {
    p5Instance = new p5(sketch, containerRef);
    createGlobalAPI();

    const handleStart = () => window.MiaAPI?.startSpeaking?.();
    const handleEnd = () => window.MiaAPI?.stopSpeaking?.();

    window.addEventListener("speech-start", handleStart);
    window.addEventListener("speech-end", handleEnd);

    onCleanup(() => {
      window.removeEventListener("speech-start", handleStart);
      window.removeEventListener("speech-end", handleEnd);
      if (p5Instance) p5Instance.remove();
      clearTimeout(smoothingTimeout);
      delete window.MiaAPI;
    });
  });

  return (
    <div
      ref={containerRef}
      style={{
        width: "300px",
        aspectRatio: "1 / 1",
      }}
    />
  );
};

export default Mia;
